/*
 * Copyright (c) 2022. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* personeel_functie.ts
* 8-3-2021 - Jelmer Jellema - Spin in het Web B.V.
*/

import {Basemodel, ModelField, ModelRelation} from './basemodel';
import {Functie} from './functie';
import {DateTime} from 'luxon';

export class PersoneelFunctie extends Basemodel {
  static table = 'personeelvast_functie';

  //owner: personeel - dus die doen we niet als veld
  @ModelField() override id: number = null;
  @ModelField() functie_id: number;
  @ModelField() hoofdfunctie: boolean = false;
  @ModelField() einddatum_certificering: string = null; //yyyy-mm-dd, laatste geldige dag; null = geen einddatum

  @ModelRelation({model: Functie, type: "1:1"}) functie: Functie;

  /**
   * Geeft true als de certificering voor deze functie op de opgegeven datum nog geldig is. Zonder
   * einddatum is dat altijd zo; met einddatum geldt de certificering tot en met die dag. Zonder
   * datum kijken we naar vandaag.
   * @param datum yyyy-mm-dd
   */
  public geldigOp(datum: string = DateTime.now().toISODate()): boolean {
    return !this.einddatum_certificering || !datum || datum <= this.einddatum_certificering;
  }
}
